// Meta Pixel event tracking helper.
// The base fbq snippet is loaded globally via public/index.html.
//
// Every event fires with a `content_category` of "game" | "series" | "trip"
// so Meta Ads Manager can slice conversion metrics per event type.
// This is what makes campaign optimization meaningful for Pouls.

function track(eventName, params = {}) {
  if (typeof window.fbq === "function") {
    try {
      window.fbq("track", eventName, params);
    } catch (e) {
      // Never let pixel errors crash the app
      console.warn("[MetaPixel]", eventName, "failed:", e);
    }
  }
}

// Normalize inputs and always include content_category + content_type.
function base(contentCategory, contentId, contentName, extra = {}) {
  return {
    content_type: "product",
    content_category: contentCategory,
    content_ids: contentId ? [contentId] : [],
    content_name: contentName || "",
    ...extra,
  };
}

export const MetaPixel = {
  // Signup — email or google
  completeRegistration: (method = "email") => {
    track("CompleteRegistration", { content_name: "signup", method });
  },

  // -------------- ViewContent (fired when user opens a detail page) --------------
  viewContent: (contentCategory, contentId, contentName, value = 0, currency = "GBP") => {
    track("ViewContent", base(contentCategory, contentId, contentName, { value, currency }));
  },

  // -------------- InitiateCheckout (fired right before Stripe / free reserve) --------------
  initiateCheckout: (contentCategory, contentId, contentName, value = 0, currency = "GBP", extras = {}) => {
    track("InitiateCheckout", base(contentCategory, contentId, contentName, { value, currency, ...extras }));
  },

  // -------------- Purchase (fired on the /payment/success page after Stripe confirms) --------------
  purchase: (contentCategory, contentId, contentName, value = 0, currency = "GBP") => {
    track("Purchase", base(contentCategory, contentId, contentName, { value, currency }));
  },

  // -------------- Schedule (free booking — no Stripe) --------------
  schedule: (contentCategory, contentId, contentName) => {
    track("Schedule", base(contentCategory, contentId, contentName));
  },

  // -------------- Legacy helpers (game-only) — kept for backwards compat --------------
  // NOTE: These are now thin wrappers around the categorised methods so existing
  // callers keep working. Prefer the explicit versions above in new code.
  viewGame: (gameId, gameName, value = 0, currency = "GBP") =>
    MetaPixel.viewContent("game", gameId, gameName, value, currency),
  initiateGameCheckout: (value, currency, gameId, gameName) =>
    MetaPixel.initiateCheckout("game", gameId, gameName, value, currency),
  gamePurchase: (value, currency, gameId, gameName = "") =>
    MetaPixel.purchase("game", gameId, gameName, value, currency),
  scheduleGame: (gameId, gameName) =>
    MetaPixel.schedule("game", gameId, gameName),
};
